/* @ngInject */
const myAreaEditForm = () => {
  return {
    restrict: 'E',
    scope: {
      myArea: '=',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myAreaEditForm.html'),

    /* @ngInject */
    controller: (
      $scope,
      areaAsk
    ) => {
      $scope.updateArea = (_area) => {
        areaAsk.update(_area, true)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myAreaEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/directives/forms/myAreaEditForm.js